import { resetNotify } from 'slices/notifySlice';
import { resetOffer } from 'slices/offerSlice';

export const resetOfferAndNotify = async (dispatch) => {
  dispatch(resetOffer());
  dispatch(resetNotify());
};
